import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';
import ProfileEdit from './ProfileEdit';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getProfile} from '../actions/profileAction';

const $= window.$;

class ChangeProfile extends Component {
	constructor(props) {
		super(props);
        this.state={

         	details : [],
         	corp:[],
         	sentdetails:[],
         	display:'none',
         	show:'block',



        };
        
        this.remove = this.remove.bind(this);
        this.getEditform = this.getEditform.bind(this);
        this.regenarateCode = this.regenarateCode.bind(this);
        // this.getactive = this.getactive.bind(this);
        this.props.getProfile();
	}

	remove(){
		Common.reactLoader("show", "Please wait...");
	    let lr_id = Common.getUserData("id", true);


   		fetch(Config.domainUrl +"user/remove-photo", {
	        method: "POST",
	        headers: {
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
                'Authorization':'Bearer ' +Common.getTokenData()
	          },
	        body: JSON.stringify({
			        learner_id:lr_id,
                  })
	       }).then((response) => response.json()).then((responseJson) => {
	       	 	Common.reactLoader("hide");
	       	 	//alert(JSON.stringify(responseJson));
	       		 if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {
			  //     	setTimeout(() => {
					// 	this.getDetails();

					// }, 100);
					// let pho = '';
					// Common.setUserData('photo_lr',pho,true);
					// this.props.ChangedPro(pho);
					this.props.getProfile();
			        Common.message("", responseJson.message , "success");
			        

			      }
	       });
	}

	// getactive(val){

	// 	if(val){
	// 		setTimeout(() => {
	// 			this.getDetails();
	// 		}, 500);
	// 	}
	// 	this.props.ChangedPro(val);
	// }



	regenarateCode(){
		Common.reactLoader("show", "Please wait...");
	    let lr_id = Common.getUserData("id", true);


   		fetch(Config.domainUrl +"user/regenerate-appcode", {
	        method: "POST",
	        headers: {
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
				'Authorization':'Bearer ' +Common.getTokenData()
	          },
	        body: JSON.stringify({
			        learner_id:lr_id,
                  })
	       }).then((response) => response.json()).then((responseJson) => {
	       	 	Common.reactLoader("hide");
	       	 	//alert(JSON.stringify(responseJson));
	       		 if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {

			        Common.message("", responseJson.message , "success");
			      }
	       });


	}

	componentWillReceiveProps(nextProps) {
		// setTimeout(() => {
		// 	this.getDetails();
		// }, 500);
		this.setState({
   			details : nextProps.profile.learner,
   			corp: nextProps.profile.corp,
   			sentdetails :nextProps.profile,
   			show:'block',
			display:'none',

   		});

	}


	getEditform(){
		this.setState({
			show:'none',
			display:'block',
		})
		 $('.edit_form').css('display', 'block');
	}




    componentDidMount() {


    	// this.getDetails();


			// Common.showSmallLeftMenu();
    }




		render() {

			let app = (this.state.corp != undefined || this.state.corp != null)?this.state.corp.appcode:0;

			(app == 1) ? app = <input type="button" className="button-blue" onClick={(e)=>this.regenarateCode(e)} value="Generate New Appcode" alt="Generate New Appcode" title="Generate New Appcode"/> : app = "";

			let edit = (this.state.corp != undefined || this.state.corp != null)?this.state.corp.but_show:0;

			(edit != 2) ? edit =   <div className="remove-btn">
				                         <input type="button" value="Remove" name="img_remove" className="remove" alt="Remove" title="Remove" onClick={(e)=>this.remove(e)}/>
				                    </div>
				         :
				            edit = '';
										let productID = Common.getUserData('productID', true);
			let occupation = (this.state.details != undefined || this.state.details != null)?this.state.details.occupation:0;

			(occupation == 1) ?

			   occupation =
			   			     <div className="acc-inner-left view_form">
						          <ul>
												{(productID !=418 && productID !=419) ?
						              <li><label>Date of Birth </label>
						                  <span>{(this.state.corp.dob)?this.state.corp.dob:'-----'}</span>
						              </li>
													: ''
													}
						               <li><label>Dept of study</label>
											<span>{(this.state.details.studying)?this.state.details.studying:'-----'}</span>
									   </li>
									   <li><label>Year of study</label>
											<span>{(this.state.details.yearofstudy)?this.state.details.yearofstudy:'-----'}</span>
									    </li>
										<li><label>College Location </label>
											<span>{(this.state.details.location)?this.state.details.location:'-----'}</span>
										</li>
										<li><label>College Name </label>
	                              	  		<span>{(this.state.details.college)?this.state.details.college:'-----'}</span>
	                              		</li>
	                              		<li><label className="label-txt">Additional info about Me</label>
																{/* <span>{(this.state.details!=undefined || this.state.details != null)?this.state.details.aboutyourself:'-----'}</span> */}
																<span>{(this.state.details.aboutyourself)?this.state.details.aboutyourself:'-----'}</span>
						                </li>
						          </ul>
						    </div>


			 : (occupation == 2) ?

			    occupation = <div className="acc-inner-left view_form">
						          <ul>
											{(productID !=418 && productID !=419) ?
						              <li><label>Date of Birth </label>
															{/* <span>{(this.state.corp != undefined || this.state.corp != null)?this.state.corp.dob:'-----'}</span> */}
															<span>{(this.state.corp.dob)?this.state.corp.dob:'-----'}</span>
						              </li>
													: ''
												}
						               <li><label>Designation</label>
											<span>{(this.state.details.designation)?this.state.details.designation:'-----'}</span>
										</li>
										<li><label>Experience</label>
											<span>{(this.state.corp.experience)?this.state.corp.experience:'-----'}</span>
										</li>
										<li><label>Education</label>
											<span>{(this.state.details.education)?this.state.details.education:'-----'}</span>
										</li>
										<li><label>Office Location</label>
											<span>{(this.state.details.location)?this.state.details.location:'-----'}</span>
										</li>
										<li><label className="label-txt">Additional info about Me</label>
																{/* <span>{(this.state.details!=undefined || this.state.details != null)?this.state.details.aboutyourself:'-----'}</span> */}
																<span>{(this.state.details.aboutyourself)?this.state.details.aboutyourself:'-----'}</span>
						                </li>

						          </ul>
					        </div>

			: occupation = <div className="acc-inner-left view_form">
						          <ul>
											{(productID!=418 && productID!=419) ?
						              <li><label>Date of Birth </label>
						                  <span>{(this.state.corp.dob)?this.state.corp.dob:'-----'}</span>
						              </li>
													: ''
													}
						               <li><label>Occupation</label>
											<span>{(this.state.details.others)?this.state.details.others:'-----'}</span>
										</li>
										<li><label>Location</label>
											<span>{(this.state.details.location)?this.state.details.location:'-----'}</span>
										</li>
										<li><label className="label-txt">Additional info about Me</label>
						                  <span>{(this.state.details.aboutyourself)?this.state.details.aboutyourself:'-----'}</span>
						                </li>
						          </ul>
					        </div>


			return (


					<div className="tabgrey viewobservers my-account">
						<div className="profile-inner" id="profile-inner" style={{display:this.state.show}}>

					        <div className="acc-lft view_form">
					        	<div className="profile-top">
					                <div className="pphoto" dangerouslySetInnerHTML={{__html: (this.state.corp != undefined || this.state.corp != null)?this.state.corp.photo:''}}/>
				                    <div className="profile-rht">

				                        <ul className="pro-list">
				                            <li>Profile image should have minimum width 200px and minimum height of 200px</li>
				                            <li>Make sure to save changes after changing the image.</li>
				                        </ul>
				                        <form method="post">
				                            {edit}
				                    	</form>
				                    </div>
									<ul className="pro-right">
										<li><label>Customer Name</label>
										<span className="box-name">{(this.state.corp != undefined || this.state.corp != null)?this.state.corp.corporate:''}</span></li>
										<li  style={{'border-style': 'solid','border-color':'#817a77'}}> Please note : You can <strong>modify</strong> your <strong>First Name</strong> and <strong>Last Name</strong> only once <br />
										<span><input type="button" value="Modify Now" className="edit" alt="Modify Now" title="Modify Now" onClick={(e)=>this.getEditform(e)}/></span></li>
										<li><label>First Name</label>
										<span>{(this.state.details.firstname)?this.state.details.firstname:'-----'}</span></li>
										<li><label>Last Name</label>
										<span>{(this.state.details.lastname)?this.state.details.lastname:'-----'}</span></li>
										<li><label>Email Id</label>
										<span>{(this.state.details.email)?this.state.details.email:'-----'}</span></li>
									</ul>
					             </div>
					        </div>
					       	{occupation}
					        <div className="acc-inner-left acc-inner-rht view_form">
					         	<ul>
					         	    <li><label>Gender</label>
									    <span>{(this.state.corp.gender)? this.state.corp.gender:'--------'}</span>
									</li>
					             	<li><label>Mobile No</label>
					                    <span>{(this.state.details.mobile)? this.state.details.country_code+'-'+this.state.details.mobile:'-----'}</span>
					              	</li>
					                <li><label>City / Town </label>
					                      <span>{(this.state.details.citytown)?this.state.details.citytown:'-----'}</span>
					                </li>
					                <li><label>Region / State </label>
					                      <span>{(this.state.details.regionstate)?this.state.details.regionstate:'-----'}</span>
					                  </li>
					                <li><label>Country </label>
										  	<span>{(this.state.corp.country_name)?this.state.corp.country_name:'-----'}</span>
									</li>
					          	</ul>
					        </div>
					        <div className="acc-btn view_form">

					        	<input type="button" value="Edit Details" className="edit" alt="Edit Details" title="Edit Details" onClick={(e)=>this.getEditform(e)}/>
					        	{app}
					        </div>

						</div>

						<div className="profile-inner" id="profile-inner1" style={{display:this.state.display}}>
					       <ProfileEdit sentdetails={this.state.sentdetails}  />
					    </div>
				</div>



			);
		}
}


function mapStateToProps(state, ownProps) {      
  
  return {
    profile: state.profile
  };
}

function mapDispatchToProps(dispatch) {
      
  return  bindActionCreators({getProfile}, dispatch);
 
}

export default connect(mapStateToProps,mapDispatchToProps)(ChangeProfile);


// WEBPACK FOOTER //
// ./src/my_profile/ChangeProfile.js